import { useMemo } from 'react';
import {
  FieldType,
  SingleSelectField,
  SourceType,
} from 'components/organisms/tasks/fields';
import { useTranslation } from 'hooks/use-translation';
import { useAllCompanies } from 'queries/account';
import { getRandomColor } from '../get-random-color';

export const useCustomerField = (
  fieldId: number,
): { customerField: SingleSelectField; isLoading: boolean } => {
  const { data: companies, isLoading } = useAllCompanies();
  const fieldLabel = useTranslation('project.fields.customer');

  return useMemo(
    () => ({
      customerField: {
        fieldId,
        fieldName: 'customer',
        fieldLabel,
        type: FieldType.SingleSelect,
        customField: false,
        private: false,
        metaData: {
          options: (companies ?? []).map((company) => ({
            label: company.companyName,
            value: company.companyId,
            imageUrl: company.companyLogoUrl,
            active: true,
            color: getRandomColor(company.companyId),
          })),
        },
        sourceType: SourceType.Project,
      },
      isLoading,
    }),
    [companies, fieldId, fieldLabel, isLoading],
  );
};
